/* BikeParts – Light beam banner: product switcher, auto-rotate, add to basket, countdown */
(function () {
  /* Auto cut-out: removes the plain white background from product photos (flood fill from the edges),
     so the light floats on the banner. Falls back to the soft tile if the photo can't be read. */
  function cutOut(img) {
    var tile = img.closest('.bpbm__tile'); if (!tile || tile.dataset.cut) return; tile.dataset.cut = 'busy';
    function giveUp() { tile.dataset.cut = 'no'; tile.classList.remove('is-pending'); }
    function run() {
      var src = img.currentSrc || img.src; if (!src) return giveUp();
      var im = new Image(); im.crossOrigin = 'anonymous';
      im.onload = function () { work(im); }; im.onerror = giveUp; im.src = src;
    }
    function work(im) {
      try {
        var w = im.naturalWidth, h = im.naturalHeight; if (!w || !h) return giveUp();
        var k = Math.min(1, 900 / Math.max(w, h)); w = Math.round(w * k); h = Math.round(h * k);
        var c = document.createElement('canvas'); c.width = w; c.height = h;
        var x = c.getContext('2d'); x.drawImage(im, 0, 0, w, h);
        var d = x.getImageData(0, 0, w, h), p = d.data, n = w * h;
        var seen = new Uint8Array(n), q = new Int32Array(n), qh = 0, qt = 0;
        function bg(i) { var o = i * 4, r = p[o], g = p[o + 1], b = p[o + 2], mx = Math.max(r, g, b), mn = Math.min(r, g, b); return mn > 228 && mx - mn < 22; }
        function push(i) { if (!seen[i] && bg(i)) { seen[i] = 1; q[qt++] = i; } }
        for (var i = 0; i < w; i++) { push(i); push((h - 1) * w + i); }
        for (var j = 0; j < h; j++) { push(j * w); push(j * w + w - 1); }
        if (qt < (w + h)) return giveUp(); /* edges aren't white – not a white-background photo */
        while (qh < qt) {
          var cI = q[qh++], cx = cI % w;
          if (cx > 0) push(cI - 1); if (cx < w - 1) push(cI + 1); if (cI >= w) push(cI - w); if (cI < n - w) push(cI + w);
        }
        for (var t = 0; t < n; t++) {
          if (seen[t]) { p[t * 4 + 3] = 0; continue; }
          var tx = t % w, near = (tx > 0 && seen[t - 1]) || (tx < w - 1 && seen[t + 1]) || (t >= w && seen[t - w]) || (t < n - w && seen[t + w]);
          if (near) { var o = t * 4, lum = (p[o] + p[o + 1] + p[o + 2]) / 3; p[o + 3] = Math.max(0, Math.min(255, Math.round((255 - lum) * 4))); }
        }
        x.putImageData(d, 0, 0);
        img.removeAttribute('srcset'); img.removeAttribute('sizes');
        img.src = c.toDataURL('image/png');
        tile.classList.add('is-cut'); tile.classList.remove('is-pending'); tile.dataset.cut = 'yes';
      } catch (e) { giveUp(); }
    }
    if (img.complete && img.naturalWidth) run(); else { img.addEventListener('load', run, { once: true }); img.addEventListener('error', giveUp, { once: true }); }
    setTimeout(function () { if (tile.dataset.cut === 'busy') giveUp(); }, 4000);
  }

  /* Built-in cut-outs: transparent light photos stored in small theme files (assets/bp-cut-KEY-N.js) and joined here. */
  function loadScript(u) { return new Promise(function (res, rej) { var sc = document.createElement('script'); sc.src = u; sc.async = true; sc.onload = res; sc.onerror = rej; document.head.appendChild(sc); }); }
  function useCut(tile) {
    var key = tile.getAttribute('data-cut-key'), u1 = tile.getAttribute('data-cut-src'), img = tile.querySelector('img');
    if (!key || !u1 || !img || tile.dataset.cut) return; tile.dataset.cut = 'busy';
    var B = window.BPCUT = window.BPCUT || {};
    function fallback() { tile.dataset.cut = ''; if (tile.classList.contains('is-auto')) cutOut(img); else tile.classList.remove('is-pending'); }
    loadScript(u1).then(function () {
      var n = B[key + '_1'].n, ps = [];
      for (var i = 2; i <= n; i++) ps.push(loadScript(u1.replace('-1.js', '-' + i + '.js')));
      return Promise.all(ps).then(function () { var d = ''; for (var j = 1; j <= n; j++) d += B[key + '_' + j].d; return d; });
    }).then(function (d) {
      var done = function () { tile.classList.add('is-cut'); tile.classList.remove('is-pending'); tile.dataset.cut = 'yes'; };
      img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.onload = done; img.src = 'data:image/webp;base64,' + d;
      if (img.complete && img.naturalWidth) done();
    }).catch(fallback);
    setTimeout(function () { if (tile.dataset.cut === 'busy') fallback(); }, 8000);
  }

  function init(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var slides = root.querySelectorAll('.bpbm__slide');
    var thumbs = root.querySelectorAll('.bpbm__thumb');
    var cur = 0, timer = null, paused = false;
    var every = parseInt(root.getAttribute('data-rotate') || '0', 10) * 1000;
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function show(i) {
      if (!slides.length) return;
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-on', n === cur); s.setAttribute('aria-hidden', n === cur ? 'false' : 'true'); });
      thumbs.forEach(function (t, n) { t.setAttribute('aria-selected', n === cur ? 'true' : 'false'); t.tabIndex = n === cur ? 0 : -1; });
    }
    function start() { stop(); if (every > 0 && !still && slides.length > 1) timer = setInterval(function () { if (!paused) show(cur + 1); }, every); }
    function stop() { if (timer) clearInterval(timer); timer = null; }

    thumbs.forEach(function (t, n) {
      t.addEventListener('click', function () { show(n); stop(); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); show(cur + (e.key === 'ArrowRight' ? 1 : -1)); thumbs[cur].focus(); stop(); }
      });
    });
    var stage = root.querySelector('.bpbm__stage');
    if (stage) {
      stage.addEventListener('mouseenter', function () { paused = true; });
      stage.addEventListener('mouseleave', function () { paused = false; });
      stage.addEventListener('focusin', function () { paused = true; });
      stage.addEventListener('focusout', function () { paused = false; });
    }
    root.querySelectorAll('.bpbm__tile[data-cut-key]').forEach(useCut);
    root.querySelectorAll('.bpbm__tile.is-pending:not([data-cut-key]) img').forEach(cutOut);
    show(0); start();

    root.querySelectorAll('form.bpbm__add').forEach(function (f) {
      f.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        var b = f.querySelector('button'), label = b.innerHTML;
        b.disabled = true; b.textContent = 'Adding…';
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(f) })
          .then(function (r) { if (!r.ok) throw r; return r.json(); })
          .then(function () {
            b.textContent = 'Added ✓';
            var p = f.closest('.bpbm__panel'); if (p) p.classList.add('is-added');
            fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
              document.querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble span, .header__cart-count').forEach(function (el) { el.textContent = c.item_count; });
              ['cart:refresh', 'cart:updated', 'cart:change'].forEach(function (n) { document.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: { cart: c } })); });
            }).catch(function () {});
          }, function () { b.disabled = false; b.innerHTML = label; f.submit(); })
          .finally(function () { setTimeout(function () { b.disabled = false; b.innerHTML = label; }, 2500); });
      });
    });

    var cd = root.querySelector('[data-bpbm-cd]');
    if (cd) {
      var end = new Date(cd.getAttribute('data-bpbm-cd')).getTime();
      if (!isNaN(end)) {
        var pad = function (n) { return (n < 10 ? '0' : '') + n; };
        var tick = function () {
          var t = Math.max(0, Math.floor((end - Date.now()) / 1000));
          if (t <= 0) { cd.hidden = true; clearInterval(ct); return; }
          cd.hidden = false;
          cd.querySelector('[data-d]').textContent = pad(Math.floor(t / 86400));
          cd.querySelector('[data-h]').textContent = pad(Math.floor(t % 86400 / 3600));
          cd.querySelector('[data-m]').textContent = pad(Math.floor(t % 3600 / 60));
        };
        var ct = setInterval(tick, 15000); tick();
      }
    }
  }
  function all() { document.querySelectorAll('.bpbm[data-bpbm]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
  document.addEventListener('shopify:block:select', function (e) {
    var s = e.target && e.target.closest ? e.target.closest('.bpbm__slide') : null;
    if (!s) return; var root = s.closest('.bpbm'); var i = Array.prototype.indexOf.call(root.querySelectorAll('.bpbm__slide'), s);
    var t = root.querySelectorAll('.bpbm__thumb')[i]; if (t) t.click();
  });
})();
